interface Pronoun {
  field: string;
  label: string;
  value: string;
}

interface Tense {
  tense_label: string;
  tense: string;
  pronouns: Pronoun[];
}

class UmatillaConjugations extends HTMLElement {
  connectedCallback() {
    const data = JSON.parse(this.dataset.conjugations || "[]") as Tense[];
    const partOfSpeech = (this.dataset.partOfSpeech || "").split(" ");
    if (
      data.filter((tense) => tense.pronouns.filter((entry) => !!entry.value).length)
        .length
    ) {
      const button = document.createElement("button");
      button.classList.add("conjugations-toggle");
      button.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-list"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
        Show Conjugations
        `;
      const dialog = document.createElement("dialog");
      dialog.classList.add("conjugations-dialog");
      const table = document.createElement("table");
      table.classList.add("conjugations-table");
      const tableWrapper = document.createElement("div");
      tableWrapper.classList.add("conjugations-table-wrapper");
      tableWrapper.append(table);
      tableWrapper.setAttribute("tabindex", "0");
      const thead = document.createElement("thead");
      const tbody = document.createElement("tbody");
      const mobileCards = document.createElement("ol");
      mobileCards.setAttribute("tabindex", "0");
      if (this.dataset.term) {
        const caption = document.createElement("caption");
        caption.textContent = `Conjugations for ${this.dataset.term}`;
        table.prepend(caption);
      }
      mobileCards.setAttribute("role", "list");
      mobileCards.classList.add("conjugations-mobile-cards");
      data.forEach((tense) => {
        if (!thead.childElementCount) {
          const headerRow = document.createElement("tr");
          const headerCell = document.createElement("th");
          headerCell.textContent = "tense";
          headerCell.scope = "col";
          headerRow.append(headerCell);
          tense.pronouns.forEach((pronoun) => {
            const th = document.createElement("th");
            th.scope = "col";
            th.textContent = pronoun.label;
            if (
              partOfSpeech.includes("vi") &&
              pronoun.field.includes("singular_first_person")
            ) {
              // do nothing
            } else if (
              partOfSpeech.includes("vt") &&
              pronoun.field.includes("singular_third_person")
            ) {
              // do nothing
            } else {
              headerRow.append(th);
            }
          });
          thead.append(headerRow);
        }
        const row = document.createElement("tr");
        const tenseHeader = document.createElement("th");
        tenseHeader.textContent = tense.tense_label;
        tenseHeader.scope = "row";
        row.append(tenseHeader);
        tense.pronouns.forEach((pronoun) => {
          const cell = document.createElement("td");
          cell.textContent = pronoun.value;
          if (
            partOfSpeech.includes("vi") &&
            pronoun.field.includes("singular_first_person")
          ) {
            // do nothing
          } else if (
            partOfSpeech.includes("vt") &&
            pronoun.field.includes("singular_third_person")
          ) {
            // do nothing
          } else {
            row.append(cell);
          }
        });
        tbody.append(row);
        const mobileCard = document.createElement("li");
        mobileCard.classList.add("conjugations-mobile-card");
        mobileCard.innerHTML = `
            <p class="conjugations-mobile-card-header" id="mobile-header-${tense.tense.replaceAll("/", " ").replaceAll("(", " ").replaceAll(")", " ").replaceAll(" ", "-")}">${tense.tense_label}</p>
            <dl aria-describedby="mobile-header-${tense.tense.replaceAll("/", " ").replaceAll("(", " ").replaceAll(")", " ").replaceAll(" ", "-")}">
                ${tense.pronouns
                  .map(
                    (pronoun) => `<dt>${pronoun.label}</dt><dd>${pronoun.value}</dd>`
                  )
                  .join("")}
            </dl>
            `;
        mobileCards.append(mobileCard);
      });
      table.append(thead);
      table.append(tbody);
      dialog.append(tableWrapper);
      dialog.append(mobileCards);
      const closeButton = document.createElement("button");
      closeButton.textContent = "Close";
      closeButton.classList.add("conjugations-close");
      closeButton.addEventListener("click", () => {
        dialog.close();
      });
      const actions = document.createElement("div");
      actions.classList.add("conjugations-actions");
      actions.append(closeButton);
      dialog.append(actions);
      button.addEventListener("click", () => {
        dialog.showModal();
      });
      this.append(button, dialog);
    }
  }
}

customElements.define("umatilla-conjugations", UmatillaConjugations);
